module.exports = __webpack_public_path__ + "static/media/agnus-dei-original-p2.00026ae1.jpg";